import { Injectable, InjectByToken } from '@jkhy/frontend-utils/di';
import { JhHttpClient } from '@jkhy/frontend-utils/http';
import { type FetchFn, FetchFnToken } from '@treasury/utils';
import { ConfigurationService } from '../config';

/**
 * HTTP Client that wraps a `fetch()` implementation
 * to include Treasury Management-specific headers and behavior.
 */
@Injectable()
export class TmBffHttpClient extends JhHttpClient {
    constructor(
        @InjectByToken(FetchFnToken) fetchFn: FetchFn,
        configService: ConfigurationService
    ) {
        super(fetchFn, {
            baseUrl: () => Promise.resolve(`/bff/${configService.institutionId}/nag`),
        });
    }
}
